module.exports = __webpack_public_path__ + "static/media/youconnect.e29d78db.jpg";